import Vue from 'vue'
import VueI18n from 'vue-i18n'

import translations from 'src/translations'

// Define locales
export const locales = [
    {
        lang: 'fr',
        code: 'fr-ca',
    },
    {
        lang: 'en',
        code: 'en-ca',
    },
]

// Set default local
export const defaultLocal = locales[0]

// Set current local
export const currentLocal = locales.find(local => local.lang === window.location.pathname.split('/')[1]) || defaultLocal

// Use plugin
Vue.use(VueI18n)

// Instanciate plugin
export const i18n = new VueI18n({
    locale: currentLocal.lang || defaultLocal.lang,
    fallbackLocale: currentLocal.lang || defaultLocal.lang,
    messages: translations
})
